import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registered',
  templateUrl: './registered.component.html',
  styleUrls: ['./registered.component.scss']
})
export class RegisteredComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  toGiftRegister(): void {
    window.location.href = 'mbbank://?ad_dp=marketplaceapp&code=PHZTMTLOA';
  }

  toBuyLoa(): void {
    window.location.href = 'mbbank://?ad_dp=active_account_hkd';
  }
}
